const KL_STICKY_ATC_SELECTOR = '[data-kl-sticky-atc]';
const KL_STICKY_ATC_ADD_SELECTOR = '[data-kl-sticky-atc-add]';
const KL_STICKY_ATC_LABEL_SELECTOR = '[data-kl-sticky-atc-label]';
const KL_STICKY_ATC_PRICE_SELECTOR = '[data-kl-sticky-atc-price]';
const KL_STICKY_ATC_BUTTON_PRICE_SELECTOR = '[data-kl-sticky-atc-button-price]';
const KL_STICKY_ATC_IMAGE_SELECTOR = '[data-kl-sticky-atc-image]';
const KL_STICKY_ATC_PRICE_VALUE_SELECTOR = '[data-kl-price-current]';
const KL_STICKY_ATC_SELECTED_VARIANT_SELECTOR = '[data-selected-variant]';
const KL_STICKY_ATC_FOOTER_SELECTOR = '.kl-footer';
const KL_STICKY_ATC_VISIBLE_CLASS = 'is-visible';
const KL_STICKY_ATC_IMAGE_WIDTH = 160;
const KL_STICKY_ATC_BODY_CLASS = 'is-sticky-atc-visible'

function getResizedImageUrl(source, width) {
  try {
    const url = new URL(source);

    url.searchParams.set('width', String(width));

    return url.toString();
  } catch (error) {
    console.debug('kl-sticky-atc: the image URL could not be resized', { source, error });
    return source;
  }
}

function getIsBarVisible({ isTriggerVisible, hasScrolledPast, isFooterVisible, requiresScrollPast }) {
  if (isTriggerVisible || isFooterVisible) return false;

  return requiresScrollPast ? hasScrolledPast : true;
}

function readDisplayedPrice(priceSource) {
  if (!priceSource) return '';

  const priceValue = priceSource.querySelector(KL_STICKY_ATC_PRICE_VALUE_SELECTOR);

  return (priceValue?.textContent || '').trim();
}

function readSelectedVariant(variantHost) {
  const script = variantHost?.querySelector(KL_STICKY_ATC_SELECTED_VARIANT_SELECTOR);

  if (!script) return null;

  try {
    return JSON.parse(script.textContent);
  } catch (error) {
    console.debug('kl-sticky-atc: the selected variant could not be read', { error });
    return null;
  }
}

function syncBar(refs) {
  const { root, triggerButton, priceSource, addButton } = refs;

  try {
    const variantHost = document.getElementById(root.dataset.klStickyAtcVariants || '');
    const variant = readSelectedVariant(variantHost);
    const isUnavailable = variant === null && Boolean(variantHost);
    const isSoldOut = Boolean(triggerButton?.disabled) || (variant ? variant.available === false : false);
    const preOrderLabel = root.dataset.klStickyAtcPreOrderLabel;
    const isPreOrder = !isSoldOut && preOrderLabel && triggerButton?.textContent.trim() === preOrderLabel;

    addButton.disabled = Boolean(triggerButton?.disabled) || isUnavailable;

    const label = root.querySelector(KL_STICKY_ATC_LABEL_SELECTOR);

    if (label) {
      if (isUnavailable) {
        label.textContent = root.dataset.klStickyAtcUnavailableLabel;
      } else if (isPreOrder) {
        label.textContent = preOrderLabel;
      } else if (isSoldOut) {
        label.textContent = root.dataset.klStickyAtcSoldOutLabel;
      } else {
        label.textContent = root.dataset.klStickyAtcLabel;
      }
    }

    const price = readDisplayedPrice(priceSource);

    if (price) {
      root.querySelectorAll(`${KL_STICKY_ATC_PRICE_SELECTOR}, ${KL_STICKY_ATC_BUTTON_PRICE_SELECTOR}`).forEach(
        (target) => {
          target.textContent = price;
        }
      );
    }

    const image = root.querySelector(KL_STICKY_ATC_IMAGE_SELECTOR);
    const variantImageSource = variant?.featured_image?.src;

    if (image && variantImageSource) {
      const resized = getResizedImageUrl(variantImageSource, KL_STICKY_ATC_IMAGE_WIDTH);

      if (image.src !== resized) {
        image.src = resized;
        image.removeAttribute('srcset');
      }
    }
  } catch (error) {
    console.debug('kl-sticky-atc: the bar could not be brought up to date', { error });
  }
}

function initStickyAtc(root) {
  if (!root || root.dataset.klStickyAtcReady === 'true') return;

  const triggerButton = document.getElementById(root.dataset.klStickyAtcTrigger || '');
  const productForm = document.getElementById(root.dataset.klStickyAtcForm || '');
  const addButton = root.querySelector(KL_STICKY_ATC_ADD_SELECTOR);

  if (!triggerButton || !productForm || !addButton) {
    console.debug('kl-sticky-atc: the bar could not find the product form it belongs to', {
      triggerId: root.dataset.klStickyAtcTrigger,
      formId: root.dataset.klStickyAtcForm,
    });
    return;
  }

  root.dataset.klStickyAtcReady = 'true';

  const refs = {
    root,
    triggerButton,
    addButton,
    priceSource: document.getElementById(root.dataset.klStickyAtcPriceSource || ''),
  };

  const state = {
    isTriggerVisible: true,
    hasScrolledPast: false,
    isFooterVisible: false,
    requiresScrollPast: root.dataset.klStickyAtcRequireScrollPast === 'true',
  };

  const applyVisibility = () => {
    root.classList.toggle(KL_STICKY_ATC_VISIBLE_CLASS, getIsBarVisible(state));
    document.body.classList.toggle(KL_STICKY_ATC_BODY_CLASS, getIsBarVisible(state))
  };

  new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      state.isTriggerVisible = entry.isIntersecting;

      if (!entry.isIntersecting) state.hasScrolledPast = entry.boundingClientRect.top < 0;
    });

    applyVisibility();
  }).observe(triggerButton);

  if (root.dataset.klStickyAtcHideAtFooter === 'true') {
    const footer = document.querySelector(KL_STICKY_ATC_FOOTER_SELECTOR);

    if (footer) {
      new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          state.isFooterVisible = entry.isIntersecting;
        });

        applyVisibility();
      }).observe(footer);
    } else {
      console.debug('kl-sticky-atc: no page footer was found, so the bar will not step aside for it');
    }
  }

  const productInfo = document.getElementById(root.dataset.klStickyAtcInfo || '');

  if (productInfo) {
    let pendingFrame = null;

    new MutationObserver(() => {
      if (pendingFrame !== null) return;

      pendingFrame = requestAnimationFrame(() => {
        pendingFrame = null;
        refs.priceSource = document.getElementById(root.dataset.klStickyAtcPriceSource || '');
        syncBar(refs);
      });
    }).observe(productInfo, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['disabled'],
    });
  }

  addButton.addEventListener('click', () => {
    if (addButton.disabled) return;

    try {
      productForm.requestSubmit(triggerButton.disabled ? undefined : triggerButton);
    } catch (error) {
      console.debug('kl-sticky-atc: the product form could not be submitted', { error });
    }
  });

  syncBar(refs);
  applyVisibility();
}

document.querySelectorAll(KL_STICKY_ATC_SELECTOR).forEach(initStickyAtc);

document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll(KL_STICKY_ATC_SELECTOR).forEach(initStickyAtc);
});
